import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  page: {
    display: 'flex',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default useStyles;
